import { BaseObject } from "@adgate/common/types/base-object.type";

export class Privilege extends BaseObject
{
    public static ADMI_CREATEANYUSER: number        = 10;
    public static ADMI_CREATEROLE: number           = 11;
    public static ADMI_CREATEOFFICEUSERS: number    = 12;
    public static ADMI_EDITAGENCIES: number         = 13;
    public static ADMI_EDITOFFICEAGENCIES: number   = 14;
    public static ADMI_EDITOFFICES: number          = 15;
    // public static MGMT_EDITOCOUNTRIES: number       = 16;

    public static COMM_VIEWHISTORY: number          = 21;
    public static COMM_EDITHISTORY: number          = 22;
    public static COMM_UPLOADCOMMERCIAL: number     = 31;
    public static COMM_UPDATECOMMERCIAL: number     = 32;

    public static STRM_VIEWHISTORY: number          = 40;
    public static STRM_UPLOADCREATIVITY: number     = 41;
    public static STRM_UPDATECREATIVITY: number     = 42;
    public static STRM_UPDATEORDER: number          = 43;
    public static STRM_EDITHISTORY: number          = 44;

    public static PROD_VIEWHISTORY: number          = 50;
    public static PROD_UPDATEVERSION: number        = 51;
    public static PROD_UPDATEORDER: number          = 52;
    public static PROD_EDITHISTORY: number          = 53;

    public static GENE_DOWNLOADDOCUMENT: number     = 60;
    public static GENE_DOWNLOADPROXY: number        = 61;
}